import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { WelcomeScreen } from "./components/WelcomeScreen";
import { GameRenderer } from "./components/GameRenderer";
import { Quiz } from "./components/Quiz";
import { ScoreDisplay } from "./components/ScoreDisplay";
import { RoomCreator } from "./components/RoomCreator";
import { AutoRoom } from "./components/AutoRoom";
import { SpectatorView } from "./components/SpectatorView";
import { AdminPage } from "./components/AdminPage";
import { AdminDashboard } from "./components/AdminDashboard";
import { AdminSchedule } from "./components/AdminSchedule";
import { DecorTest } from "./components/DecorTest";
import { DocPage } from "./components/DocPage";
import { PodiumTest } from "./components/PodiumTest";
import { useGameStore } from "./store";

function GameComponent() {
  const { gameStarted } = useGameStore();

  if (!gameStarted) {
    return <WelcomeScreen />;
  }

  return (
    <div className="relative w-full h-screen">
      <ScoreDisplay />
      <GameRenderer />
      <div className="relative z-50">
        <Quiz />
      </div>
    </div>
  );
}

// Repli pour toute URL inconnue. Sans lui, React Router ne matche rien et rend
// une page BLANCHE muette : une faute de frappe, ou un bundle plus vieux que
// l'URL demandée (cas typique d'un conteneur pas encore redéployé), donnait un
// écran vide sans le moindre indice.
function NotFound() {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen font-kawaii bg-gradient-to-br from-sakura-100 via-lavender-100 to-sky-100 flex items-center justify-center p-4">
      <div className="bg-white/80 backdrop-blur-xl rounded-blob shadow-kawaii-lg border-2 border-sakura-200/50 p-8 text-center max-w-md">
        <p className="text-5xl font-black text-sakura-400 mb-3">404</p>
        <p className="font-extrabold text-lavender-500 mb-1">Page not found</p>
        <p className="text-sm font-bold text-gray-400 mb-6 break-all">{pathname}</p>
        <a
          href="/"
          className="inline-block px-6 py-3 rounded-xl bg-gradient-to-r from-sakura-400 to-lavender-400 text-white font-black shadow-kawaii-card"
        >
          Back to home
        </a>
      </div>
    </div>
  );
}

function PageTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    (window as { plausible?: (e: string) => void }).plausible?.("pageview");
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <PageTracker />
      <Routes>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/sets" element={<AdminPage />} />
        <Route path="/admin/all-sets" element={<AdminPage allMode />} />
        <Route path="/admin/schedule" element={<AdminSchedule />} />
        <Route path="/auto-room" element={<AutoRoom />} />
        <Route path="/create-room" element={<RoomCreator />} />
        <Route path="/spectate" element={<SpectatorView />} />
        <Route path="/decor-test" element={<DecorTest />} />
        <Route path="/doc" element={<DocPage />} />
        <Route path="/podium-test" element={<PodiumTest />} />
        <Route path="/" element={<GameComponent />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
